var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(-13.903 -14.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220-2",
    "data-name": "Group 220",
    transform: "translate(13.903 14.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M30.878,21.079a.478.478,0,0,0-.677,0l-4.3,4.3-4.3-4.3a.479.479,0,1,0-.677.677l4.3,4.3-4.3,4.3a.479.479,0,0,0,.677.677l4.3-4.3,4.3,4.3a.479.479,0,0,0,.677-.677l-4.3-4.3,4.3-4.3A.478.478,0,0,0,30.878,21.079ZM25.9,14.054a12,12,0,1,0,12,12A12.013,12.013,0,0,0,25.9,14.054Zm0,23.043h0A11.042,11.042,0,1,1,36.945,26.054,11.056,11.056,0,0,1,25.9,37.1Z",
    transform: "translate(-13.903 -14.054)",
    fill: "#888"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9a5d1940.svg";
export { ForwardRef as ReactComponent };